import { ThunkAction } from "redux-thunk";
import { AppStateType, InferActionsTypes } from "../reducers/store";
import { api } from "../api/api";
import { IAuth } from "../entities/Auth";
import cookie from "js-cookie";
import { message } from "antd";
import {
  ROUTE_ADMIN,
  ROUTE_HOME,
  ROUTE_MOBILE_CATALOG_LIST,
} from "../constants/appRoutes";
import { isMobile } from "react-device-detect";
import { basename } from "../constants/constants";

export const DO_AUTH = "DO_AUTH";
export const SET_TOKEN = "SET_TOKEN";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
export const TOGGLE_IS_AUTH_FETCHING = "TOGGLE_IS_AUTH_FETCHING";

type ActionsTypes = InferActionsTypes<typeof authActions>;
type ThunkType = ThunkAction<
  Promise<void>,
  AppStateType,
  unknown,
  ActionsTypes
>;

export const authActions = {
  setToken: (token: string) => ({ type: SET_TOKEN, token }),
  setUserData: (
    id: number,
    login: string,
    name: string,
    role: string,
    firstAuth: boolean,
    code: string,
    userType: string,
    data: any
  ) => ({
    type: SET_USER_DATA,
    id,
    login,
    name,
    role,
    firstAuth,
    code,
    userType,
    data,
  }),
  setInitialState: () => ({ type: SET_INITIAL_STATE }),
  toggleIsAuthFetching: (isFetching: boolean) => ({
    type: TOGGLE_IS_AUTH_FETCHING,
    isFetching,
  }),
};

export const requestLogin =
  (
    login: string,
    password: string,
    reload: boolean,
    token?: string | null
  ): ThunkType =>
  async (dispatch, getState) => {
    dispatch(authActions.toggleIsAuthFetching(true));
    let response: any = undefined;

    //if (token) response = await api.loginByToken(token);
    //else
    response = await api.login(login, password);

    let data_user: any = null;

    if (response) {
      cookie.set("login", login);
      cookie.set("password", password);
      cookie.set("token", response.token);

      if (response.data) {
        data_user = {
          code: response.data.code,
          is_not_1c: response.data.is_not_1c,
          order_in_email: response.data?.reception_options.order_in_email
        };
      }
      
      cookie.set("userData", {
        id: response.user.id,
        name: response.user.name,
        role: response.user.role,
        firstAuth: response.user.first_auth,
        code: response.user.code,
        type: response.user.type,
        data: data_user,
      });
      cookie.remove("shop");
      cookie.remove("supplier");

      const checkInnShop = await api.requestGetClient({
        cmd: "checkLinkExists",
        user: login,
      });

      dispatch(
        authActions.setUserData(
          response.user.id,
          response.user.login,
          response.user.name,
          response.user.role,
          response.user.first_auth,
          response.user.code,
          response.user.type,
          response.data
        )
      );
      dispatch(authActions.setToken(response.token));

      if (reload) {
        if (response.user.role === "investor") {
          window.location.href = basename + ROUTE_ADMIN;
        } else if (
          (checkInnShop && checkInnShop.linked) ||
          response.user.role === "admin" ||
          response.user.role === "supplier" ||
          response.user.role === "partner" ||
          response.user.role === "manager"
        ) {
          if (isMobile)
            window.location.href = basename + ROUTE_MOBILE_CATALOG_LIST;
          else window.location.href = basename + ROUTE_HOME;
        } else {
          window.location.href =
            basename + "/settings/web/inn/setting/?token=" + response.token;
        }
      }
    } else {
      message.warning("Не удалось войти. Проверьте введенный логин или пароль");
    }
    dispatch(authActions.toggleIsAuthFetching(false));
  };

export const requestVerifyUser = (code: string) => {
  return api.verifyUser(code);
};

export const requestLoginAfterVerify =
  (data: any): ThunkType =>
  async (dispatch, getState) => {
    cookie.set("login", data.user.login);
    cookie.set("password", data.user.psw);
    cookie.set("token", data.token);
    
    cookie.set("userData", {
      id: data.user.id,
      name: data.user.name,
      role: data.user.role,
      firstAuth: data.user.first_auth,
      code: data.user.code,
      type: data.user.type,
    });

    dispatch(
      authActions.setUserData(
        data.user.id,
        data.user.login,
        data.user.name,
        data.user.role,
        data.user.first_auth,
        data.user.code,
        data.user.type,
        data.data
      )
    );
    dispatch(authActions.setToken(data.token));
  };

export const readUserDataFromCookies =
  (): ThunkType => async (dispatch, getState) => {
    if (cookie.get("userData") !== undefined) {
      const userData: any = JSON.parse(cookie.get("userData")!);
      if (userData) {
        const login = cookie.get("login")!;
        dispatch(
          authActions.setUserData(
            userData.id,
            login,
            userData.name,
            userData.role,
            userData.firstAuth,
            userData.code,
            userData.type,
            userData.data
          )
        );
        dispatch(authActions.setToken(cookie.get("token")!));
      }
    }
  };

export const signupUser = (
  login: any,
  psw: any,
  name: any,
  email: any,
  oktmo: any
) => {
  return api.signupUser(login, psw, name, email, oktmo);
};

export const doLogout = (): ThunkType => async (dispatch, getState) => {
  cookie.remove("login");
  cookie.remove("password");
  cookie.remove("token");
  cookie.remove("userData");
  cookie.remove("shop");
  cookie.remove("supplier");
  dispatch(authActions.setInitialState());
};

export const loginCheck = (login: string) => {
  return api.loginCheck(login);
};

export const getUser = () => {
  return api.getUser();
};

export const changePsw = (oldpsw: string, newpsw: string) => {
  return api.changePsw(oldpsw, newpsw);
};
